const data = [
	{
		id: 0,
		title: 'BLOOMS: Strobe Animated Sculptures Invented by John Edmark',
		provider: 'VIMEO',
		movieUrl: 'https://www.vimeo.com/116582567',
		imageUrl: 'https://i.vimeocdn.com/video/505594453_295x166.jpg',
		publishedAt: '2015-01-12 14:58:02',
		favourite: false,
	},
	{
		id: 1,
		title: 'First One (A Quest to Become More Beautiful)',
		provider: 'VIMEO',
		movieUrl: 'https://www.vimeo.com/527942089',
		imageUrl: 'https://i.vimeocdn.com/video/1092885695_640.jpg',
		publishedAt: '2021-03-23 14:13:51',
		likes: undefined,
		views: undefined,
		favourite: true,
	},
	{
		id: 2,
		title: 'SEAWOLF',
		provider: 'VIMEO',
		movieUrl: 'https://www.vimeo.com/527079690',
		imageUrl: 'https://i.vimeocdn.com/video/1091141651_640.jpg',
		publishedAt: '2021-03-21 21:50:51',
		favourite: false,
		likes: undefined,
		views: undefined,
	},
	{
		id: 3,
		title: 'Branko Feat. Nonku Phiri & Mr. Carmack - Let Me Go',
		provider: 'YOUTUBE',
		movieUrl: 'https://www.youtube.com/watch?v=IaRB87UmM2E',
		imageUrl: 'https://i.ytimg.com/vi/IaRB87UmM2E/mqdefault.jpg',
		publishedAt: '2016-01-29T00:07:23Z',
		likes: '680',
		views: '56651',
		favourite: true,
	},
	{
		id: 4,
		title: 'How to Shoot for NIKE',
		provider: 'YOUTUBE',
		movieUrl: 'https://www.youtube.com/watch?v=_9wBIq0dohM',
		imageUrl: 'https://i.ytimg.com/vi/_9wBIq0dohM/mqdefault.jpg',
		publishedAt: '2021-03-22T13:00:24Z',
		likes: '8174',
		views: '85701',
		favourite: false,
	},
	{
		id: 5,
		title: 'Top 5 Tips To Make You A Better Web Designer',
		provider: 'YOUTUBE',
		movieUrl: 'https://www.youtube.com/watch?v=6Q4KVKaVv9s',
		imageUrl: 'https://i.ytimg.com/vi/6Q4KVKaVv9s/mqdefault.jpg',
		publishedAt: '2021-03-29T16:30:01Z',
		likes: '2875',
		views: '31543',
		favourite: false,
	},
	{
		id: 6,
		title: 'Lil Nas X - MONTERO (Call Me By Your Name)',
		provider: 'VIMEO',
		movieUrl: 'https://www.vimeo.com/529254176',
		imageUrl: 'https://i.vimeocdn.com/video/1095287599_640.jpg',
		publishedAt: '2021-03-26 05:07:03',
		favourite: true,
	},
	{
		id: 7,
		title: 'MIŁY ATZ – COPYPASTE (prod. @atutowy)',
		provider: 'YOUTUBE',
		movieUrl: 'https://www.youtube.com/watch?v=EN86lF9VlK0',
		imageUrl: 'https://i.ytimg.com/vi/EN86lF9VlK0/mqdefault.jpg',
		publishedAt: '2020-02-18T10:59:01Z',
		likes: '8804',
		views: '327172',
		favourite: true,
	},
	{
		id: 1617327254374,
		title: 'Node.js and Express.js - Full Course',
		provider: 'YOUTUBE',
		movieUrl: 'https://www.youtube.com/watch?v=Oe421EPjeBE',
		imageUrl: 'https://i.ytimg.com/vi/Oe421EPjeBE/mqdefault.jpg',
		publishedAt: '2021-04-01T12:37:58Z',
		likes: '1483',
		views: '18010',
		favourite: false,
	},
];

export default data;
